export enum CustomNode {
    ConsoleOutputDisableExpressionNode = 'ConsoleOutputDisableExpressionNode',
    DebugProtectionFunctionCallNode = 'DebugProtectionFunctionCallNode',
    DebugProtectionFunctionIntervalNode = 'DebugProtectionFunctionIntervalNode',
    DebugProtectionFunctionNode = 'DebugProtectionFunctionNode',
    DomainLockNode = 'DomainLockNode',
    NodeCallsControllerFunctionNode = 'NodeCallsControllerFunctionNode',
    SelfDefendingUnicodeNode = 'SelfDefendingUnicodeNode',
    StringArrayCallsWrapper = 'StringArrayCallsWrapper',
    StringArrayNode = 'StringArrayNode',
    StringArrayRotateFunctionNode = 'StringArrayRotateFunctionNode'
}
